(function () {
    'use strict';

    angular
        .module('app')
        .directive('selectioncommandapprove', selectioncommand_approve);

    selectioncommand_approve.$inject = ['$window'];

    function selectioncommand_approve($window) {
        // Usage:
        //     <toolbar></toolbar>
        // Creates:
        //
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                approveDialogShown: '=?'
            },
            controller: 'approve',
            templateUrl: 'app/selectioncommand/selectioncommand_approve.html'
        };
        return directive;

        function link(scope, element, attrs) {

            
        }
    }
})();